export interface RgbaData {
  colorCode: string;
  alpha: number;
}

/**
 * カラーコードをrgbに変換したり16進数に変換したりするモジュール
  */

export class ColorCodeConverter {

  static colorCodeToRgb(colorCode: string): string {
    // 先頭に#が含まれている場合は除外
    if (colorCode.split('')[0] === '#') {
      colorCode = colorCode.substring(1);
    }

    // カラーコードが省略されている場合は6桁に戻す
    if (colorCode.length === 3) {
      const codeAry = colorCode.split('');
      colorCode = codeAry[0] + codeAry[0] + codeAry[1] + codeAry[1] + codeAry[2] + codeAry[2];
    }

    // カラーコードが6桁でない場合（強制的に黒にする）
    if (colorCode.length !== 6) {
      return 'rgb(0, 0, 0)';
    }
    const r = parseInt(colorCode.substring(0, 2), 16);
    const g = parseInt(colorCode.substring(2, 4), 16);
    const b = parseInt(colorCode.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b})`;
  }

  // rgbをカラーコードに変換して返す
  static rgbToColorCode(rgb: string): string {
    const colorAry = rgb.match(/(?<=\().*?(?=\))/);
    const rgbaAry = colorAry![0].split(',');
    return '#' + rgbaAry.map(value => ('0' + Number(value).toString(16)).slice(-2)).join('');
  };

  // rgbaをカラーコードとalphaに変換しオブジェクトで返す
  static rgbaToColorCode(rgba: string): RgbaData {
    const colorAry = rgba.match(/(?<=\().*?(?=\))/);
    const rgbaAry = colorAry![0].split(',');
    const alpha = Number(rgbaAry.pop());
    const colorCode = '#' + rgbaAry.map(value => ('0' + Number(value).toString(16)).slice(-2)).join('');
    return { colorCode, alpha };
  };

  // カラーコードのゼロをサプレスする
  static suppressZero = (str: string) => {
    let i = 0;
    while (str.charAt(i) === '0') i++;
    return (str.slice(i) || '0');
  };

  // カラーコードにゼロをパディングする
  static paddingZero = (str: string) => {
    return str.padStart(6, '0')
  };

  /**
   * カラーコードを16進数に変換する
   * @param {string} color
   * @returns {number}
   */
  static Color2Hex = (color: string): string => {
    // # を取り除く
    let cleanHex = color.replace("#", "");

    // 3桁なら6桁に変換（例: "abc" → "aabbcc"）
    if (cleanHex.length === 3) {
      cleanHex = cleanHex.split("").map(c => c + c).join("");
    }

    // 16進数の数値に変換して 0x をつける
    return '0x' + cleanHex;
  };

  static Hex2Color = (_hex: string): string => {
    // # を取り除く
    let cleanHex = _hex.replace("0x", "");

    // 3桁なら6桁に変換（例: "abc" → "aabbcc"）
    if (cleanHex.length === 3) {
      cleanHex = cleanHex.split("").map(c => c + c).join("");
    }

    // 16進数の数値に変換して 0x をつける
    return '#' + cleanHex;
  };

  /**
   * BGR → RGB（hex文字列版）
   * @param bgrStr 16進文字列（例: "0x112233"）
   * @returns RGB 16進文字列（例: "0x332211"）
   */
  static bgrToRgbHex(bgrStr: string): string {
    const bgr = parseInt(bgrStr.replace(/^0x/, ''), 16);
    const b = (bgr >> 16) & 0xff;
    const g = (bgr >> 8) & 0xff;
    const r = bgr & 0xff;
    const rgb = (r << 16) | (g << 8) | b;
    return '0x' + rgb.toString(16).padStart(6, '0');
  }

  /**
   * RGB → BGR（hex文字列版）
   * @param rgbStr 16進文字列（例: "0x112233"）
   * @returns BGR 16進文字列（例: "0x332211"）
   */
  static rgbToBgrHex(rgbStr: string): string {
    const rgb = parseInt(rgbStr.replace(/^0x/, ''), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = rgb & 0xff;
    const bgr = (b << 16) | (g << 8) | r;
    return '0x' + bgr.toString(16).padStart(6, '0');
  }
}
